export default "__VITE_ASSET__CTReRaM2__"